import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Cumul pour les prestations
 */
export class Cumul implements ListItem {
	/** Données */
	idCumul: number;
	libelle: string;
	type: TypeCumul;

	constructor(dto?: any) {
		if (dto) {
			Object.assign(this,dto);
		}
	}

	getKey(): number {
		return this.idCumul;
	}
}

/**
 * Cumul pour les prestations avec affichage
 */
export class DisplayCumul extends Cumul {
	display: string;

	constructor(dto?: any) { super(dto); }
}

/**
 * Enumération des types de cumul
 */
export enum TypeCumul {
	TYPE_JOURNALIER = 1,
	TYPE_OPERATION = 2
}